var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _g6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThyroid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2071_20527",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 10,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1105 3H3.47656V21H12.1105V3Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2071_20527)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.92188 20.1816L12.1121 20.2316",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.45312 16.1934C8.86287 18.2944 8.82385 20.1328 8.82385 20.1328",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8817 6.88902C12.1207 7.27285 11.4964 6.95972 11.3208 6.83851C10.6086 6.37387 10.5403 5.6971 10.1305 4.93952C9.57446 3.91932 8.37447 3.48498 7.33059 3.93952C5.2526 4.83851 2.93073 8.63649 5.03799 9.45467C6.25747 9.92942 7.07695 11.091 7.64279 12.4749",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2071_20527",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 3,
    width: 9,
    height: 18
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7452 3H12.1113V21H20.7452V3Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2071_20527)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.2917 20.1816L12.1113 20.2316",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7604 16.1934C15.3507 18.2944 15.3897 20.1328 15.3897 20.1328",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3301 6.88902C12.091 7.27285 12.7154 6.95972 12.891 6.83851C13.6032 6.37387 13.6715 5.6971 14.0812 4.93952C14.6373 3.91932 15.8373 3.48498 16.8812 3.93952C18.9592 4.83851 21.2811 8.63649 19.1738 9.45467C17.9543 9.92942 17.1348 11.091 16.569 12.4749",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2071_20527",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 8,
    width: 7,
    height: 12
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.31204 8.89062H3V19.6987H9.31204V8.89062Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2071_20527)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.89199 9.64844L4.66762 9.94137C4.17008 10.5878 3.96519 11.4363 4.10177 12.2545L4.23836 13.0929L4.02373 13.5575C3.43838 14.7899 3.73107 16.2848 4.73592 17.1535L4.91152 17.305L5.39931 17.8404C6.57977 19.1333 8.57973 18.9313 8.57973 18.9313",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_2071_20527",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 8,
    width: 8,
    height: 12
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0015 8.89062H14.6895V19.6987H21.0015V8.89062Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_2071_20527)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1076 9.64844L19.332 9.94137C19.8296 10.5878 20.0344 11.4363 19.8979 12.2545L19.7613 13.0929L19.9759 13.5575C20.5613 14.7899 20.2686 16.2848 19.2637 17.1535L19.0881 17.305L18.6003 17.8404C17.4199 19.1333 15.4199 18.9313 15.4199 18.9313",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_2071_20527",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 11,
    width: 7,
    height: 7
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9937 11.3945H5.70117V17.1117H11.9937V11.3945Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_2071_20527)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.43359 12.1523C6.58969 12.6271 12.0334 12.7483 12.1895 12.6978",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.53516 16.3538C9.55462 15.6063 13.2911 15.6568 13.3399 15.7477",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_2071_20527",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 11,
    width: 8,
    height: 7
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2866 11.3945H11.9941V17.1117H18.2866V11.3945Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_2071_20527)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5548 12.1523C17.3987 12.6271 11.9549 12.7483 11.7988 12.6978",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4531 16.3538C14.4337 15.6063 10.6972 15.6568 10.6484 15.7477",
    stroke: "#03122E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThyroid);
export default __webpack_public_path__ + "static/media/Thyroid.367281185737d4033c71c789c08368ce.svg";
export { ForwardRef as ReactComponent };